// extracted by mini-css-extract-plugin
module.exports =  {"highway":"a10a3f92e9--highway--TV8oi","highway_distance":"a10a3f92e9--highway_distance--p4YW6","highway_link":"a10a3f92e9--highway_link--f6r6c","icon":"a10a3f92e9--icon--QV4PD"};